import React from 'react';
import I18n from 'i18n-js';
import { RCAlertBox } from '@reverbdotcom/cadence/components';

const PHRASE_FLAGS = [
  'seller',
  'sold',
  'shipped',
  'ship',
  'shipment',
  'shipping',
  'arrived',
  'transaction',
  'delivery',
  'refund',
  'damaged',
  'returned',
  'condition',
  'deal',
  'money back',
  'offer',
  'do business',
  'doing business',
  'fraud',
  'fraudulent',
  'scam',
  'as described',
  'fast shipping',
  'thank you',
  'description',
];

const PHRASE_FLAGS_REGEX = new RegExp(`\\b(${PHRASE_FLAGS.join('|')})\\b`, 'gi');

export function ProductReviewWarning(props: { review: string }) {
  const shouldDisplayWarning = props.review.length && props.review.match(PHRASE_FLAGS_REGEX);

  if (!shouldDisplayWarning) return null;

  return (
    <div className="scaling-mb-4">
      <RCAlertBox type="error">
        {I18n.t('discovery.productReviews.reviewWarning.warning')}
      </RCAlertBox>
    </div>
  );
}
